export function isContentEmptyCheck(str: string) {
    return str.trim() === '';
}
